<template>
  <div class="col-12 col-xl-4 col-lg-6 mb-5">
    <router-link class="text-decoration-none text-black" :to="{name: 'Details'}">
      <div :class="meeting.status === 'inactive' ? 'inactive' : ''" class="card custom-card bg-white border-0">
        <div class="p-4">
          <div class="d-flex align-items-center">
            <div :class="meeting.status === 'running' ? 'text-success' : 'text-warning'" class="me-auto status">
              <div class="d-flex align-items-center gap-2">
                <div :class="meeting.status === 'running' ? 'bg-success' : 'bg-warning'" class="status-circle"></div>
                <div class="fs-12px" v-if="meeting.status == 'running'">قيد التشغيل</div>
                <div class="fs-12px" v-if="meeting.status == 'stopped'">متوقف مؤقتا</div>
                <div class="fs-12px" v-if="meeting.status == 'inactive'">معطل</div>
              </div>
            </div>
          <div class="dropdown">
            <button class="btn p-0 dropdown-toggle" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
              <img src="@/assets/images/dots.svg" alt="" />
            </button>
            <ul class="dropdown-menu rounded-3 border-0 shadow-sm dropdown-menu-end" aria-labelledby="dropdownMenuButton1">
              <li>
                <button class="dropdown-item border-bottom" @click="successToast()" type="button">تعيين كإفتراضي</button>
              </li>
              <li>
                <button data-bs-toggle="modal" data-bs-target="#removeCardModal" class="dropdown-item" type="button">حذف الكارد</button>
              </li>
            </ul>
          </div>
          </div>
          <h1 class="fw-bold mt-1 fs-4">{{ meeting.title }}</h1>
          <div class="text-secondary fs-12px">{{ meeting.date }}</div>
        </div>
        <div class="p-4 border-top border-bottom">
          <div class="text-secondary mb-2 f-7">المنصة</div>
          <div class="d-flex align-items-center gap-2 mb-3 platforms">
            <img v-if="meeting.platform.includes('zoom')" src="@/assets/images/zm-02_2x.png" class="pe-2 border-end" alt="" />
            <img v-if="meeting.platform.includes('google')" src="@/assets/images/2560px-Google_Meet_text_logo_(2020).svg_2x.png" alt="" />
          </div>
          <div class="text-secondary mb-2 f-7">المدة</div>
          <span class="fw-bold f-7">{{ meeting.duration }}</span>
        </div>
        <div class="px-4 py-3">
          <div class="d-flex align-items-center justify-content-between">
            <button :disabled="meeting.status === 'inactive'" class="btn btn-outline-primary btn-sm d-flex align-items-center rounded-pill fs-12px px-2 py-1" type="button">
              <div class="svg-icon me-2">
                <svg id="ic-content-copy-48px" xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17">
                  <path id="Path_5" data-name="Path 5" d="M0,0H17V17H0Z" fill="none" />
                  <path
                    id="icon"
                    data-name="Path 6"
                    d="M13.854,2H5.408A1.41,1.41,0,0,0,4,3.414v9.9H5.408v-9.9h8.447Zm2.112,2.827H8.223A1.41,1.41,0,0,0,6.816,6.241v9.9a1.41,1.41,0,0,0,1.408,1.414h7.743a1.41,1.41,0,0,0,1.408-1.414v-9.9A1.41,1.41,0,0,0,15.966,4.827Zm0,11.309H8.223v-9.9h7.743Z"
                    transform="translate(-2.549 -1.275)"
                    fill="currentColor"
                  />
                </svg>
              </div>
              نسخ الرابط
            </button>
            <router-link :class="meeting.status === 'inactive' ? 'disabled' : ''" class="btn btn-outline-secondary btn-sm d-flex align-items-center rounded-pill fs-12px px-2 py-1" :to="{name: 'Details'}">
              <div class="svg-icon me-2">
                <svg id="icons_design-grid_Filled" data-name="icons/design-grid/Filled" xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12">
                  <g id="Shape">
                    <path id="_87F46107-E17A-4394-98EE-1EC3B3E8D59F" data-name="87F46107-E17A-4394-98EE-1EC3B3E8D59F" d="M0,1.2A1.2,1.2,0,0,1,1.2,0H2.7A.3.3,0,0,1,3,.3V2.7a.3.3,0,0,1-.3.3H.3A.3.3,0,0,1,0,2.7Z" fill="currentColor" />
                    <path id="_469D606D-A2B2-4759-9E72-364250DB5084" data-name="469D606D-A2B2-4759-9E72-364250DB5084" d="M0,.3A.3.3,0,0,1,.3,0H2.7A.3.3,0,0,1,3,.3v3a.3.3,0,0,1-.3.3H.3A.3.3,0,0,1,0,3.3Z" transform="translate(0 4.2)" fill="currentColor" />
                    <path id="C09B64F4-0AB1-4E05-B853-E7BC96F371F1" d="M.3,0A.3.3,0,0,0,0,.3V1.8A1.2,1.2,0,0,0,1.2,3H2.7A.3.3,0,0,0,3,2.7V.3A.3.3,0,0,0,2.7,0Z" transform="translate(0 9)" fill="currentColor" />
                    <path id="CD88DAE5-2522-4577-B17B-49C1D6880D7C" d="M.3,0A.3.3,0,0,0,0,.3V2.7A.3.3,0,0,0,.3,3h3a.3.3,0,0,0,.3-.3V.3A.3.3,0,0,0,3.3,0Z" transform="translate(4.2 9)" fill="currentColor" />
                    <path id="_8D05E260-A1E9-4325-818F-761AD8F22F6D" data-name="8D05E260-A1E9-4325-818F-761AD8F22F6D" d="M.3,0A.3.3,0,0,0,0,.3V2.7A.3.3,0,0,0,.3,3H1.8A1.2,1.2,0,0,0,3,1.8V.3A.3.3,0,0,0,2.7,0Z" transform="translate(9 9)" fill="currentColor" />
                    <path id="DBF074F9-34D6-483C-9A41-571F1E44233D" d="M3,3.3a.3.3,0,0,1-.3.3H.3A.3.3,0,0,1,0,3.3V.3A.3.3,0,0,1,.3,0H2.7A.3.3,0,0,1,3,.3Z" transform="translate(9 4.2)" fill="currentColor" />
                    <path id="EDF646C1-927B-4415-BC56-9C1955CF8EA0" d="M3.6,3.3a.3.3,0,0,1-.3.3H.3A.3.3,0,0,1,0,3.3V.3A.3.3,0,0,1,.3,0h3a.3.3,0,0,1,.3.3Z" transform="translate(4.2 4.2)" fill="currentColor" />
                    <path id="B7D6CCB7-AB4A-4930-A694-AAE9768D395A" d="M0,2.7A.3.3,0,0,0,.3,3h3a.3.3,0,0,0,.3-.3V.3A.3.3,0,0,0,3.3,0H.3A.3.3,0,0,0,0,.3Z" transform="translate(4.2)" fill="currentColor" />
                    <path id="A15E2F69-1C53-49A2-A924-F9C5E84A2D77" d="M0,2.7A.3.3,0,0,0,.3,3H2.7A.3.3,0,0,0,3,2.7V1.2A1.2,1.2,0,0,0,1.8,0H.3A.3.3,0,0,0,0,.3Z" transform="translate(9)" fill="currentColor" />
                  </g>
                </svg>
              </div>
              عرض صفحة الحجوزات
            </router-link>
          </div>
        </div>
      </div>
    </router-link>
  </div>
</template>

<script>
export default {
  props: ['meeting'],
}
</script>